import React, { useEffect, useState, useRef } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  Box,
  Button,
  TextField,
  MenuItem,
  Select,
  Tooltip,
  Menu,
  Typography,
  IconButton,
  Checkbox,
  FormControl,
  FormControlLabel,
  Autocomplete,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  InputAdornment,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from "react-router-dom";
import { CiCirclePlus, CiExport,
  //  CiFilter 
  } from "react-icons/ci";
import dayjs from "dayjs";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { PiCopyFill } from "react-icons/pi";
// import { FaClone } from "react-icons/fa6";
import { Offcanvas } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { IoIosArrowBack } from "react-icons/io";
import { grey, red, teal } from "@mui/material/colors";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import { ExpandMore } from "@mui/icons-material";
import { useTheme } from "../../ThemeContext";
import { createEntity, filterEntities, getAllData } from "../../apis/apiService";
import { format } from "date-fns";
import { toast } from "react-toastify";
import SearchBar from "../../components/SearchBar";
import { useSelector } from "react-redux";
// import { CustomNoRowsOverlay } from "../projects/Project";
import Loader from "../../components/common/Loader";import
//  CommonDeleteDialog, 
 {
  CommonDeactivate,
} from "../../components/common/CommonDelete";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {
  useFetchCreateDatasMutation,
  useFetchExportUsersMutation,
  useFetchGetallDepartmentsQuery,
  useFetchGetAllMasterDesignationsQuery,
  useFetchGetAllSkillsQuery,
} from "../../slice/logdetailSlice";
import { CustomNoRowsOverlay } from "../../components/common/OverlayGrid";


const AddMilestoneComponent = ({
  onApply,
  onClear,
  onCancel,
  FetchPortalUsers,
}) => {
  const Designation = [
    "Designer",
    "Frontend developer",
    "Backend developer",
    "Tester",
  ];
  const [loading, setLoadding] = useState(false);
  // const Role = ['Employee', 'Manager', 'Administrator', 'Contractor'];
  const pickerRef = useRef(null);
  const Role = ["EMPLOYEE", "MANAGER", "ADMIN", "CONTRACTOR"];
  const Years = Array.from({ length: 100 }, (_, i) => i);
  const Months = Array.from({ length: 12 }, (_, i) => i);
  const Departments = ["Testing", "FrontEnd"];
  const [openModal, setOpenModal] = useState(false);
  const [inviteLink, setInviteLink] = useState("");
  const ProjectNameOptions = useSelector((state) => state.selectOptions?.ProjectNameOptions);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const { data: get_all_designations = [], refetch: designation_refetch } = useFetchGetAllMasterDesignationsQuery();
  const { data: department_list = [], refetch: department_list_refetch } = useFetchGetallDepartmentsQuery();
  const { data: skills_list = [], refetch: skills_list_refetch } = useFetchGetAllSkillsQuery();

  useEffect(() => {
    designation_refetch();
    department_list_refetch();
    skills_list_refetch();
  }, []);
  const {
    handleSubmit,
    control,
    reset,
    register,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      email: "",
      FirstName: "",
      LastName: "",
      contactNumber: "",
      Role: "",
      Designation: "",
      RatePerHour: 0,
      CostPerHour: 0,
      Projects: [],
    },
  });
  // const emailValue = watch("email");
  // useEffect(() => {
  //   if (emailValue) {
  //     const firstPart = emailValue.split("@")[0];
  //     const secondPart = emailValue.split(".")[1];
  //     if (secondPart?.length === 2) {
  //       setValue("FirstName", firstPart[0]);
  //       setValue("LastName", secondPart[1]);
  //     }
  //   }
  // }, [emailValue, setValue]);
  const emailValue = watch("email");

  useEffect(() => {
    const trimmedEmail = emailValue?.trim();

    if (trimmedEmail) {
      const namePart = trimmedEmail.split("@")[0];
      const nameParts = namePart.split(".");

      if (nameParts.length === 2) {
        const [firstName, lastName] = nameParts;
        setValue("FirstName", firstName);
        setValue("LastName", lastName);
        if (hasSubmitted) {
          trigger(["FirstName", "LastName"]);
        }
      }
    } else {
      setValue("FirstName", "");
      setValue("LastName", "");

      if (hasSubmitted) {
        trigger(["FirstName", "LastName"]);
      }
    }
  }, [emailValue, setValue, trigger, hasSubmitted]);

  const inviteMore = async (e) => {
    e.preventDefault();
    setHasSubmitted(true);
    handleSubmit((data) => handleInviteMore(data))();
  };
  const handleInviteMore = async (data) => {
    const requestData = {
      first_name: data.FirstName,
      last_name: data.LastName,
      email: data.email,
      role: data.Role,
      phone_number: data.contactNumber,
      designation: data.designation,
      // rate_per_hour: data.RatePerHour,
      // cost_per_hour: data.CostPerHour,
      rate_per_hour: 0,
      cost_per_hour: 0,
      project_ids: data.Projects,
      department_id: data.Department,
      relevant_year: data.Year,
      relevant_month: data.Month,
      date_of_joining: data.date_of_joining?.format("YYYY-MM-DD"),
      area_of_expertise: data.Area_of_expertise,
    };

    setLoadding(true);
    try {
      // Call the API to create the entity
      const response = await getAllData("user/add", requestData);
      toast.success(response.message);

      // onCancel();
      reset();
      FetchPortalUsers();
      //  fetchIssues();
    } catch (error) {
      toast.error(error.message || "Error");
    } finally {
      setLoadding(false);
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(inviteLink);
    toast.success("Link copied to clipboard!");
  };

  const handleClose = () => {
    setOpenModal(false);
    setInviteLink("");
    onCancel();
  };
  const onSubmit = async (data) => {
    // console.log("Form submitted function reached!");
    setHasSubmitted(true);
    const requestData = {
      first_name: data.FirstName,
      last_name: data.LastName,
      email: data.email,
      role: data.Role,
      phone_number: data.contactNumber,
      designation: data.Designation,
      // rate_per_hour: data.RatePerHour,
      // cost_per_hour: data.CostPerHour,
      rate_per_hour: 0,
      cost_per_hour: 0,
      project_ids: data.Projects,
      department_id: data.Department,
      relevant_year: data.Year,
      relevant_month: data.Month,
      date_of_joining: data.date_of_joining?.format("YYYY-MM-DD"),
      area_of_expertise: data.Area_of_expertise,
    };
    // console.log("???????", requestData);

    setLoadding(true);
    try {
      // Call the API to create the entity
      const response = await getAllData("user/add", requestData);
      // toast.success(response.message);
      setInviteLink(response.invite_url);
      FetchPortalUsers();
      setOpenModal(true);
      //  fetchIssues();
    } 
    catch (error) {
      toast.error(error.message || "Error");
    } 
    finally {
      setLoadding(false);
    }
  };

  return (
    <div className="">
      <Dialog open={openModal} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>Invitation Link</DialogTitle>
        <DialogContent>
          <Typography sx={{ mb: 1 }}>
            User invited successfully! Copy the link below:
          </Typography>
          <TextField
            fullWidth
            value={inviteLink}
            InputProps={{
              readOnly: true,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={handleCopy}>
                    <ContentCopyIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="primary" variant="outlined">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <div className="d-flex align-items-center justify-content-between filter-h-bg px-4 py-3">
        <button onClick={onCancel} className="R_btn">
          <div className="d-flex  text-rgba-gray align-items-center">
            <IoIosArrowBack className=" text-rgba-gray" />
            Add New Portal Users
          </div>
        </button>
      </div>

      <div className="bg-white px-4 pt-3 overflow-scroll pb-5 ">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div>
              <div className="row ">
                <div className="col-md-12">
                  <label htmlFor="email" className="form-label">
                    Email ID <span className=" errorMsg">*</span>
                  </label>
                  <TextField
                    type="email"
                    id="email"
                    className="form-control"
                    placeholder="Enter email address"
                    {...register("email", {
                      required: "Email is required",
                      pattern: {
                        value: /^[^@\s]+@[^@\s]+\.[^@\s]+$/,
                        message: "Enter a valid email address",
                      },
                    })}
                  />
                  {errors.email && (
                    <span className=" errorMsg ">{errors.email.message}</span>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="FirstName" className="form-label">
                    First Name <span className=" errorMsg">*</span>
                  </label>
                  <TextField
                    type="text"
                    id="FirstName"
                    className="form-control"
                    placeholder="Enter First Name"
                    {...register("FirstName", {
                      required: "First name is required",
                    })}
                  />
                  {errors.FirstName && (
                    <span className="errorMsg">{errors.FirstName.message}</span>
                  )}
                </div>

                <div className="col-md-6 mt-3">
                  <label htmlFor="LastName" className="form-label">
                    Last Name <span className=" errorMsg">*</span>
                  </label>
                  <TextField
                    type="text"
                    id="LastName"
                    className="form-control"
                    placeholder="Enter Last Name"
                    {...register("LastName", {
                      required: "Last name is required",
                    })}
                  />
                  {errors.LastName && (
                    <span className="errorMsg">{errors.LastName.message}</span>
                  )}
                </div>

                {/* <div className="col-md-6 mt-3 mb-3">
                  <label htmlFor="contactNumber" className="form-label">
                    Phone Number
                  </label>
                  <div className="input-group">
                    <span
                      className="input-group-text"
                      style={{
                        backgroundColor: "var(--header-bg-color)",
                        color: "var(--text-color)",
                      }}
                    >
                      +91
                    </span>
                    <TextField
                      type="number"
                      placeholder=" Phone number"
                      id="contactNumber"
                      className="form-control"
                      {...register("contactNumber")}
                      onKeyDown={(e) => {
                        if (e.key === "-" || e.key === "e") {
                          e.preventDefault();
                        }
                      }}
                    />
                  </div>
                </div> */}

                <div className="col-md-6 mt-3 mb-3">
                  <label htmlFor="contactNumber" className="form-label">
                    Phone Number <span className="errorMsg">*</span>
                  </label>
                  <div className="input-group">
                    <span
                      className="input-group-text"
                      style={{
                        backgroundColor: "var(--header-bg-color)",
                        color: "var(--text-color)",
                      }}
                    >
                      +91
                    </span>

                    <TextField
                      type="text" // use text instead of number
                      placeholder="Phone number"
                      id="contactNumber"
                      className="form-control"
                      {...register("contactNumber", {
                        required: "Phone number is required",
                        pattern: {
                          value: /^[0-9]{10}$/, // exactly 10 digits
                          message: "Enter a valid 10-digit phone number",
                        },
                      })}
                      onInput={(e) => {
                        // remove non-digits
                        e.target.value = e.target.value.replace(/[^0-9]/g, "");

                        // stop at 10 digits
                        if (e.target.value.length > 10) {
                          e.target.value = e.target.value.slice(0, 10);
                        }
                      }}
                    />
                  </div>

                  {errors.contactNumber && (
                    <span className="errorMsg">{errors.contactNumber.message}</span>
                  )}
                </div>

                {/* <------------------------department------------------------> */}
                <div className="col-md-6 mt-3">
                  <label htmlFor="Department" className="form-label">
                    Department <span className=" errorMsg">*</span>
                  </label>
                  <FormControl fullWidth>
                    <Controller
                      name="Department"
                      control={control}
                      rules={{ required: "Department is required" }}
                      render={({
                        field: { ref, onChange, value },
                        fieldState: { error },
                      }) => (
                        <>
                          <Select
                            labelId="Department-label"
                            id="Department"
                            value={value}
                            onChange={(e) => onChange(e.target.value)}
                            inputRef={ref}
                            IconComponent={ExpandMore}
                            displayEmpty
                            renderValue={(selected) => {
                              const dept = department_list.find(
                                (d) => d.department_id === selected
                              );
                              return dept ? (
                                dept.department_name
                              ) : (
                                <span className="lightText">Department</span>
                              );
                            }}
                          >
                            {department_list.map((dept, index) => (
                              <MenuItem
                                key={dept.department_id}
                                value={dept.department_id}
                              >
                                {dept.department_name}
                              </MenuItem>
                            ))}
                          </Select>
                          {error && (
                            <span className=" errorMsg ">{error.message}</span>
                          )}
                        </>
                      )}
                    />
                  </FormControl>
                </div>

                {/* <------------------------Role------------------------> */}

                <div className="col-md-6 mt-1">
                  <label htmlFor="Role" className="form-label">
                    Role <span className=" errorMsg">*</span>
                  </label>
                  <FormControl fullWidth>
                    <Controller
                      name="Role"
                      control={control}
                      rules={{ required: "Role is required" }}
                      render={({
                        field: { ref, onChange, value },
                        fieldState: { error },
                      }) => (
                        <>
                          <Select
                            labelId="Role-label"
                            id="Role"
                            value={value}
                            onChange={(e) => onChange(e)}
                            inputRef={ref}
                            // {...control.register("Role")}
                            IconComponent={ExpandMore}
                            displayEmpty
                            renderValue={(selected) =>
                              selected ? (
                                selected
                              ) : (
                                <span className=" lightText">Role</span>
                              )
                            }
                          >
                            {Role.map((item, index) => (
                              <MenuItem key={index} value={item}>
                                {item}
                              </MenuItem>
                            ))}
                          </Select>
                          {error && (
                            <span className=" errorMsg ">{error.message}</span>
                          )}
                        </>
                      )}
                    />
                  </FormControl>
                </div>

                {/* <------------------------Designation------------------------> */}
                <div className="col-md-6 mt-1">
                  <label htmlFor="Designation" className="form-label">
                    Designation <span className=" errorMsg">*</span>
                  </label>
                  <FormControl fullWidth>
                    <Controller
                      name="Designation"
                      control={control}
                      rules={{ required: "Designation is required" }}
                      render={({
                        field: { ref, onChange, value },
                        fieldState: { error },
                      }) => (
                        <>
                          <Select
                            labelId="Designation-label"
                            id="Designation"
                            value={value}
                            onChange={(e) => onChange(e.target.value)}
                            inputRef={ref}
                            IconComponent={ExpandMore}
                            displayEmpty
                            renderValue={(selected) =>
                              selected ? (
                                selected
                              ) : (
                                <span className=" lightText">Designation</span>
                              )
                            }
                          >
                            {get_all_designations?.map((role) => (
                              <MenuItem value={role.designation_name}>
                                {role.designation_name}
                              </MenuItem>
                            ))}
                          </Select>
                          {/* <Select
                            labelId="Designation-label"
                            id="Designation"
                            value={value}
                            onChange={(e) => onChange(e.target.value)}
                            inputRef={ref}
                            IconComponent={ExpandMore}
                            displayEmpty
                            renderValue={(selected) => {
                              const desg = get_all_designations.find(
                                (desg) => desg.designation_id === selected
                              );
                              return desg ? (
                                desg.designation_name
                              ) : (
                                <span className="lightText">Designation</span>
                              );
                            }}
                          >
                            {get_all_designations.map((desg, index) => (
                              <MenuItem
                                key={desg.designation_id}
                                value={desg.designation_name}
                              >
                                {desg.designation_name}
                              </MenuItem>
                            ))}
                          </Select> */}
                          {error && (
                            <span className=" errorMsg ">{error.message}</span>
                          )}
                        </>
                      )}
                    />
                  </FormControl>
                </div>

                {/* <------------------------------------department-------------------------------------------> */}

                {/* <div className="col-md-6 mt-3">
                  <label htmlFor="Department" className="form-label">
                    Department <span className=" errorMsg">*</span>
                  </label>
                  <FormControl fullWidth>
                    <Controller
                      name="Department"
                      control={control}
                      rules={{ required: "Department  is required" }}
                      render={({
                        field: { ref, onChange, value },
                        fieldState: { error },
                      }) => (
                        <>
                          <Select
                            labelId="Deparment-label"
                            id="Department"
                            onChange={onChange}
                            value={value}
                            inputRef={ref}
                            IconComponent={ExpandMore}
                            displayEmpty
                            renderValue={(selected) =>
                              selected ? (
                                selected
                              ) : (
                                <span className="lightText">Department</span>
                              )
                            }
                          >
                            {department_list?.map((dept) => (
                              <MenuItem value={dept.department_id}>
                                {dept.department_name}
                              </MenuItem>
                            ))}
                          </Select>
                          {error && (
                            <span className=" errorMsg ">{error.message}</span>
                          )}
                        </>
                      )}
                    />
                  </FormControl>
                </div> */}

                {/* <--------------------------------------------------------> */}

                {/* <div className="col-md-6 mt-3">
                  <label htmlFor="RatePerHour" className="form-label">
                    Rate Per Hour
                  </label>
                  <TextField
                    type="number"
                    id="RatePerHour"
                    className="form-control"
                    placeholder="Enter Rate"
                    {...register("RatePerHour")}
                    onKeyDown={(e) => {
                      if (e.key === "-" || e.key === "e") {
                        e.preventDefault(); // Prevent negative and exponential input
                      }
                    }}
                  />
                  {errors.RatePerHour && (
                    <span className="errorMsg">
                      {errors.RatePerHour.message}
                    </span>
                  )}
                </div> */}
                {/* <div className="col-md-6 mt-3">
                  <label htmlFor="CostPerHour" className="form-label">
                    Cost Per Hour
                  </label>

                  <TextField
                    type="number"
                    id="CostPerHour"
                    className="form-control"
                    placeholder="Enter Cost"
                    {...register("CostPerHour")}
                    onKeyDown={(e) => {
                      if (e.key === "-" || e.key === "e") {
                        e.preventDefault();
                      }
                    }}
                  />
                  {errors.CostPerHour && (
                    <span className="errorMsg">
                      {errors.CostPerHour.message}
                    </span>
                  )}
                </div> */}
              </div>
              {/* <------------------------Relavant Experiance------------------------> */}
              <div className="row mt-2">
                {/* === Label Row === */}
                <div className="col-md-6 d-flex justify-content-between">
                  <label
                    htmlFor="RelevantExperience"
                    className="form-label mb-1"
                  >
                    Relevant Experience <span className="errorMsg">*</span>
                  </label>
                </div>
                <div className="col-md-6 d-flex justify-content-between">
                  <label style={{ marginLeft: 10 }} className="form-label mb-1">
                    {"  "}
                    Date of Joining
                  </label>
                </div>
                <div className="row mt-2">
                  {/* === Input Row === */}

                  {/* Year */}
                  <div className="col-md-3">
                    <FormControl fullWidth>
                      <Controller
                        name="Year"
                        control={control}
                        rules={{ required: "Year is required" }}
                        render={({
                          field: { ref, onChange, value },
                          fieldState: { error },
                        }) => (
                          <>
                            <Select
                              value={value}
                              onChange={onChange}
                              inputRef={ref}
                              displayEmpty
                              IconComponent={ExpandMore}
                              MenuProps={{
                                PaperProps: {
                                  style: { maxHeight: "30vh" },
                                },
                              }}
                              renderValue={(selected) =>
                                selected !== undefined && selected !== null ? (
                                  selected
                                ) : (
                                  <span className="lightText">Year</span>
                                )
                              }
                            >
                              {Years.map((item, index) => (
                                <MenuItem key={index} value={item}>
                                  {item}
                                </MenuItem>
                              ))}
                            </Select>
                            {error && (
                              <span className="errorMsg">{error.message}</span>
                            )}
                          </>
                        )}
                      />
                    </FormControl>
                  </div>
                  {/* <------------------------month------------------------> */}

                  {/* Month */}
                  <div className="col-md-3">
                    <FormControl fullWidth>
                      <Controller
                        name="Month"
                        control={control}
                        rules={{ required: "Month is required" }}
                        render={({
                          field: { ref, onChange, value },
                          fieldState: { error },
                        }) => (
                          <>
                            <Select
                              value={value}
                              onChange={onChange}
                              inputRef={ref}
                              displayEmpty
                              IconComponent={ExpandMore}
                              MenuProps={{
                                PaperProps: {
                                  style: { maxHeight: "30vh" },
                                },
                              }}
                              renderValue={(selected) =>
                                selected !== undefined && selected !== null ? (
                                  selected
                                ) : (
                                  <span className="lightText">Month</span>
                                )
                              }
                            >
                              {Months.map((item, index) => (
                                <MenuItem key={index} value={item}>
                                  {item}
                                </MenuItem>
                              ))}
                            </Select>
                            {error && (
                              <span className="errorMsg">{error.message}</span>
                            )}
                          </>
                        )}
                      />
                    </FormControl>
                  </div>
                  {/* <------------------------date of joining------------------------> */}

                  <div className="col-md-6">
                    <div
                      className=" d-flex  flex-column w-100 "
                      style={{ marginLeft: 20 }}
                    >
                      <Controller
                        name="date_of_joining"
                        control={control}
                        render={({ field }) => (
                          <DatePicker
                            {...field}
                            format="DD/MM/YYYY"
                            views={["year", "month", "day"]}
                            onChange={(date) => field.onChange(date)}
                            // maxDate={dayjs()}
                            renderInput={(params) => (
                              <TextField
                                fullWidth
                                // style={{ width: "120%" }}
                                // className="form-control datepic_ip"
                                {...params}
                              />
                            )}
                          />
                        )}
                      />
                    </div>
                  </div>
                </div>
              </div>
              {/* </div> */}

              {/* <------------------------area of expetise------------------------> */}
              <div className="mt-5 mb-5">
                <h5 className="Area_of_expertise">
                  Area of expertise
                  {/* <span className=" errorMsg">*</span> */}
                </h5>
                <div className="col-md-12 pt-4">
                  <Controller
                    name="Area_of_expertise"
                    control={control}
                    // rules={{ required: "Area of expertise field is required" }}
                    render={({ field: { ref, onChange, value } }) => (
                      <Autocomplete
                        multiple
                        inputRef={ref}
                        id="Area_of_expertise"
                        options={skills_list}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.skill_name}
                        value={
                          (value || []).map((id) =>
                            skills_list.find((opt) => opt.skill_id === id)
                          ) || []
                        }
                        onChange={(event, newValue) => {
                          const selectedIds = newValue.map(
                            (skill) => skill.skill_id
                          ); // ✅ fixed
                          onChange(selectedIds);
                        }}
                        renderOption={(props, option, { selected }) => (
                          <li
                            {...props}
                            className="d-flex align-items-center mb-2"
                          >
                            <Checkbox
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            <strong>{option.skill_name}</strong>{" "}
                            {/* ✅ fixed */}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Enter Area of Expertise"
                          />
                        )}
                        ListboxProps={{
                          style: {
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "8px",
                            paddingLeft: "0",
                          },
                        }}
                      />
                    )}
                  />
                  {/* {errors.Area_of_expertise && ( 
                    <span className="errorMsg">
                      {errors.Area_of_expertise.message}
                    </span>
                  )} */}
                </div>
              </div>

              {/* <------------------------allProjects------------------------> */}
              <div className="mt-5 mb-5">
                <h5 className="Settings_project_field">
                  All Projects <span className=" errorMsg">*</span>
                </h5>
                <div className="col-md-12 pt-4">
                  <Controller
                    name="Projects"
                    control={control}
                    rules={{ required: "Project field  is required" }}
                    render={({ field: { ref, onChange, value } }) => (
                      <Autocomplete
                        multiple
                        inputRef={ref}
                        id="Projects"
                        options={ProjectNameOptions}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.title}
                        value={
                          (value || []).map((id) =>
                            ProjectNameOptions.find(
                              (opt) => opt.project_id === id
                            )
                          ) || []
                        }
                        onChange={(event, newValue) => {
                          const selectedIds = newValue.map(
                            (project) => project.project_id
                          );
                          onChange(selectedIds);
                        }}
                        renderOption={(props, option, { selected }) => (
                          <li
                            {...props}
                            className="d-flex align-items-center mb-2"
                          >
                            <Checkbox
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            <strong>{option.title}</strong>
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Enter Projects Name"
                          />
                        )}
                        ListboxProps={{
                          style: {
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "8px",
                            paddingLeft: "0",
                          },
                        }}
                      />
                    )}
                  />
                  {errors.Projects && (
                    <span className="errorMsg">{errors.Projects.message}</span>
                  )}
                </div>
              </div>

              <div className="bg-white position-absolute bottom-0 py-3  w-100">
                <div className="d-flex justify-content-left mt-3">
                  <button
                    type="submit"
                    className="me-3 add_btn"
                    disabled={loading}
                  >
                    {loading ? "Inviting..." : "Invite"}
                  </button>
                  <button
                    type="button"
                    className="addmore_btn me-3"
                    onClick={inviteMore}
                    disabled={loading}
                  >
                    Invite More
                  </button>
                  <button
                    type="button"
                    className="cancel_btn"
                    onClick={onCancel}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </form>
        </LocalizationProvider>
      </div>
    </div>
  );
};

export const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: 0,
    margin: 2,
    transitionDuration: "300ms",
    "&.Mui-checked": {
      transform: "translateX(16px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: teal[100], // ✅ light teal when checked
        opacity: 1,
        border: 0,
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: 0.5,
      },
    },
    "&.Mui-focusVisible .MuiSwitch-thumb": {
      color: "#33cf4d",
      border: "6px solid #fff",
    },
    "&.Mui-disabled .MuiSwitch-thumb": {
      color: grey[100],
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.7,
    },
  },
  "& .MuiSwitch-thumb": {
    boxSizing: "border-box",
    width: 22,
    height: 22,
  },
  "& .MuiSwitch-track": {
    borderRadius: 13,
    backgroundColor: red[200], // ❌ light red when unchecked
    opacity: 1,
    transition: theme.transitions.create(["background-color"], {
      duration: 500,
    }),
  },
}));

const PortalUsers = () => {
  const { isDarkMode } = useTheme();
  const [expandedRows, setExpandedRows] = useState({});
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  // const [filter, setFilter] = useState(2);
    const [filter, setFilter] = useState(() => {
    const savedFilter = sessionStorage.getItem("portalUserFilter");
    return savedFilter ? parseInt(savedFilter) : 2;
  });
  const [PortalUsers, setPortalUsers] = useState([]);
  const [roleFilter, setRoleFilter] = useState("ALL");
  const [searchTerm, setSearchTerm] = useState("");
  const Years = Array.from({ length: 100 }, (_, i) => i);
  const Months = Array.from({ length: 12 }, (_, i) => i);
  const [showFilter, setShowFilter] = useState(false);
  const [showProject, setShowProject] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userDatas, setUserDatas] = useState(null);
  // console.log("User_dates>>>>", userDatas);

  const [allUsers, setAllUsers] = useState([]);
  const [paginationModal, setPaginationModal] = useState({
    page: 0,
    pageSize: 25,
  });
  const navigate = useNavigate();
  const ProjectID = localStorage.getItem("project_id");

  const { handleSubmit, control, reset } = useForm({
    defaultValues: {
      user_name: userDatas?.user_name,
      designation: userDatas?.designation,
      // rate_per_hour: userDatas?.rate_per_hour,
      rate_per_hour: "0",
      user_id: userDatas?.user_id,
      user_role: userDatas?.role,
      department_id: userDatas?.department,
      date_of_joining: userDatas?.date_of_joining
        ? dayjs(userDatas?.date_of_joining)
        : null,
      Area_of_expertise:
        userDatas?.area_of_expertise?.map((skill) => skill.skill_id) || [],
    },
  });
  const relevant_experience = userDatas?.relevant_experience?.split("Y");
  // console.log("user datas :", userDatas);
  useEffect(() => {
    if (showUpdate && userDatas) {
      const [y, m] = userDatas?.relevant_experience?.split("Y") || [];
      const years = parseInt(y || "0");
      const months = parseInt(m?.replace("M", "") || "0");

      reset({
        user_name: userDatas?.user_name,
        rate_per_hour: "0",
        user_id: userDatas.user_id,
        user_role: userDatas?.role || "",
        designation: userDatas?.designation,
        department_id: userDatas?.department_id,
        Area_of_expertise:
          userDatas?.area_of_expertise?.map((skill) => skill.skill_id) || [],
        relevant_year: years,
        relevant_month: months,
        date_of_joining: userDatas?.date_of_joining
          ? dayjs(userDatas?.date_of_joining)
          : null,
      });
    }
  }, [showUpdate, userDatas, reset]);
  // const loginUser = useSelector((state) => state.selectOptions?.loginUser);

  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  // console.log("login_user in task:", login_user);
  const { role: login_user_role, id: login_user_id } = login_user;
  // const { reset } = useForm();
  const [exportUsers] = useFetchExportUsersMutation();
  const { data: get_all_designations } =
    useFetchGetAllMasterDesignationsQuery();
  const { data: department_list = [] } = useFetchGetallDepartmentsQuery();
  const { data: skills_list = [] } = useFetchGetAllSkillsQuery();
  const [updatePortalUsers] = useFetchCreateDatasMutation();
  // console.log("form_data :", userDatas);
  const onSubmit = async (data) => {
    // console.log("form_data23 :", data);
    const requestedData = {
      name: data.user_name,
      user_id: userDatas?.user_id,
      role: data.user_role,
      designation: data.designation,
      department_id: data.department_id,
      area_of_expertise: data.Area_of_expertise,
      relevant_year: data.relevant_year,
      relevant_month: data.relevant_month,
      date_of_joining: data.date_of_joining?.format("YYYY-MM-DD"),

      // rate_per_hour: data.rate_per_hour,
    };
    try {
      const response = await updatePortalUsers({
        url: `updateUser`,
        body: requestedData,
      }).unwrap();
      if (response) {
        toast.success(response.message);
        setShowUpdate(false);
        setUserDatas(null);
        reset();
        handleMenuClose();
        FetchPortalUsers();
      }
    } catch (error) {
      toast.error(error.message);
    }
  };
  // console.log("get_all_designations :", get_all_designations);

  const columns = [
    ...(login_user_role === "ADMIN"
      ? [
          {
            field: "actions",
            headerName: "Action",
            width: 120,
            renderCell: (params) => (
              <Box display="flex" alignItems="center">
                {/* More options button */}
                <IconButton
                  onClick={(event) => {
                    event.stopPropagation();
                    handleMenuOpen(event, params.row);
                  }}
                >
                  <MoreVertIcon />
                </IconButton>
              </Box>
            ),
          },
        ]
      : []),
    {
      field: "user_name",
      headerName: "User Name",

      width: 200,
    },
    {
      field: "email",
      headerName: "Email",
      width: 200,
      // valueGetter: (params) => `${params.row.completed_percentage}%`,
    },
    {
      field: "designation",
      headerName: "Designation",
      width: 150,
    },

    {
      field: "role",
      headerName: "Role",
      width: 150,
    },
    // {
    //   field: "rate_per_hour",
    //   headerName: "Rate per Hour",
    //   width: 150,
    // },
    // {
    //   field: "cost_per_hour",
    //   headerName: "Cost per Hour",
    //   width: 150,
    // },
    {
      field: "is_accept_invitation",
      headerName: "Invitation Status",
      width: 150,
      renderCell: (params) => {
        const status = params.value;
        let color;

        // Set color based on status
        switch (status) {
          case "Accepted":
            color = "rgba(0, 191, 0, 1)";
            break;
          case "sent":
            color = "blue";
            break;
          case "Not Accepted":
            color = "red";
            break;
          case "Completed":
            color = "Green";
            break;
          default:
            color = "var(--switch-color)";
        }

        return (
          <Box
            sx={{
              color: color,
              padding: "4px 8px",
              borderRadius: "4px",
            }}
          >
            {status}
          </Box>
        );
      },
    },
    {
      field: "invite_url",
      headerName: "Invitation Link",
      width: 150,
      renderCell: (params) => {
        const inviteUrl = params.value;

        const handleCopy = (e) => {
          e.stopPropagation();
          navigator.clipboard.writeText(inviteUrl);
          toast.success("Link copied to clipboard!");
        };

        return (
          <Box className="d-flex justify-content-center align-items-center h-100">
            {inviteUrl ? (
              <button
                onClick={handleCopy}
                className="add_btn"
                style={{
                  backgroundColor: "#00bfa6",
                  color: "#fff",
                  fontSize: "13px",
                  fontWeight: "500",
                  lineHeight: "1",
                  padding: "6px 14px",
                  borderRadius: "20px",
                  border: "none",
                  cursor: "pointer",
                  height: "32px",
                  width: "70px",
                }}
              >
                Link
              </button>
            ) : (
              <span style={{ fontSize: "13px", color: "#888" }}>
                No link found
              </span>
            )}
          </Box>
        );
      },
    },
    {
      field: "password_updated_at",
      headerName: "Password Updated At",
      width: 200,
    },
    ...(login_user_role === "ADMIN"
      ? [
          {
            field: "is_active",
            headerName: "Action",
            width: 200,
            align: "center",
            // headerAlign: "center", // Optional: aligns header too
            renderCell: (params) => {
              return (
                <Box
                  display="flex"
                  alignItems="center"
                  onClick={(event) => event.stopPropagation()}
                >
                  <FormControlLabel
                    sx={{
                      m: 1.5,
                      "& .MuiFormControlLabel-label": {
                        fontSize: "0.9rem",
                      },
                    }}
                    control={
                      <IOSSwitch
                        sx={{
                          transform: "scale(0.8)",
                        }}
                        onClick={() => toggleSwitch(params.row)}
                        checked={params.value === 1}
                      />
                    }
                    label={params.value === 1 ? "Active" : "Inactive"}
                  />
                </Box>
              );
            },
          },
        ]
      : []),
    {
      field: "added_at",
      headerName: "Added At",
      width: 200,
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("DD/MM/YYYY - hh:mm A") : "-",
    },
    {
      field: "changed_by_email",
      headerName: filter === 3 ? "Activated / Deactivated By" : filter === 1 ? "Deactivated By" : "Activated By",
      width: 250,
      renderCell: (params) => params.value || "-",
    },
    {
      field: "changed_at",
      headerName: filter === 3 ? "Activated / Deactivated At" : filter === 1 ? "Deactivated At" : "Activated At",
      width: 200,
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("DD/MM/YYYY - hh:mm A") : "-",
    },
  ];

  const handleClosePopup = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    setShowUpdate(false);
    setUserDatas(null);
    reset();
    handleMenuClose();
  };
  const toggleSwitch = (row) => {
    setSelectedUser(row);
    setOpenPopup(true);
  };

  const handleCancel = () => {
    setShowUpdate(false);
    setUserDatas(null);
    reset();
    handleMenuClose();
    // setSelectedUser(null);
  };
  const fetchSearchedPortalUsers = async (searchQuery) => {
    try {
      const response = await filterEntities("user/show", {
        searchText: searchQuery,
        viewType: filter,
      });
      if (response.status) {
        setPortalUsers(
          response.data.map((project) => ({ ...project, id: project.user_id }))
        );
        setLoading(true);
      } else {
        setPortalUsers([]);
      }
    } catch (error) {
      // console.error("Failed to fetch PortalUsers:", error);
      setPortalUsers([]);
      // Handle the error appropriately in the caller
    } finally {
      setLoading(false);
    }
  };

  const FetchPortalUsers = async () => {
    setLoading(true);
    const requestData = { viewType: filter };
    try {
      const response = await filterEntities("user/show", requestData);
      if (response) {
        const data = response.data;
        setPortalUsers(data); // filtered users for display

        // Fetch all users only once if not already fetched

        const allResponse = await filterEntities("user/show", {
          viewType: 3,
        });
        if (allResponse?.data) {
          setAllUsers(allResponse.data); // store unfiltered data
        }
      } else {
        toast.error("No PortalUsers found in the response.");
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleExportUsers = async () => {
    try {
      const response = await exportUsers({
        url: "exportUsers",
        body: { view_type: filter },
      }).unwrap();
      if (response) {
        toast.success(response.messagw);
        const link = document.createElement("a");
        link.href = response.doc_url;
        link.setAttribute("download", "ExportPortalUsers.xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (err) {
      toast.error(
        err.message ||
          err?.data?.message ||
          "Something went wrong while exporting."
      );
    }
  };
  
  useEffect(() => {
    FetchPortalUsers();
  }, [filter]);
  const handleConfirmAction = async () => {
    const { user_id, user_name } = selectedUser;
    const requestedData = {
      user_id: user_id,
    };
    try {
      const response = await createEntity("changeUserStatus", requestedData);
      if (response) {
        toast.success(response.message);
        FetchPortalUsers();
        setOpenPopup(false);
        setSelectedUser(null);
      } else {
        toast.error(response.message);
        setOpenPopup(false);
        setSelectedUser(null);
      }
    } catch (error) {
      toast.error(error.message);
      setOpenPopup(false);
      setSelectedUser(null);
    }
    // console.log("params_user_value :", user_id, user_name);
  };

  const handleShowFilter = () => setShowFilter(true); // Open filter
  const handleShowProject = () => setShowProject(true); // Open filter

  const toggleExpandRow = (taskId) => {
    setExpandedRows((prev) => ({
      ...prev,
      [taskId]: !prev[taskId],
    }));
  };

  const handleMenuOpen = (event, row) => {
    console.log("selected_task  row values :", row);
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
    setSelectedTask(row);
    setUserDatas(row);
  };
  // console.log("selected_task :", selectedTask);

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedTask(null);
  };

  const handleClone = () => {
    handleMenuClose();
  };

  const handleView = () => {
    handleMenuClose();
  };
  const handleViewDitailstab = () => {
    handleMenuClose();
  };
  const handleUpdate = () => {
    // handleMenuClose();
    setShowUpdate(true);
  };

  const handleApplyFilter = (filteredData) => {
    // //console.log()("filterdata", filteredData);

    setPortalUsers(
      filteredData.map((project) => ({
        ...project,
        id: project.user_id,
      }))
    );
    // //console.log()("PortalUsers state after filter applied:", PortalUsers);

    setShowFilter(false);
  };

  const handleFilterChange = (e) => {
    const value = e.target.value;
    setFilter(value);
    sessionStorage.setItem("portalUserFilter", value);
  };

  const handleSearchChange = async (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    if (value) {
      await fetchSearchedPortalUsers(value);
    } else {
      await FetchPortalUsers();
      // setIssues([]); // Clear projects if search term is empty
    }
  };
  const filteredPortalUsers = PortalUsers.filter((user) => {
    if (roleFilter === "ALL") return true;
    return user.role?.toUpperCase() === roleFilter.toUpperCase();
  });

  const filteredAllUsers = allUsers.filter((user) => {
    if (roleFilter === "ALL") return true;
    return user.role?.toUpperCase() === roleFilter.toUpperCase();
  });

  const activeCount = filteredAllUsers.filter((user) => user.is_active === 1).length;
  const inactiveCount = filteredAllUsers.filter((user) => user.is_active === 0).length;
  const totalCount = filteredAllUsers.length;
  // console.log("user_count", user_count);

  // Handle row click
  // user_id
  const handleRowClick = (params) => {
    const { user_id } = params.row;
    navigate(`/settings/portalUsersDetail/${user_id}`);
  };

  // settings/PortalUsers/detail
  return (
    <>
      {/* Add  Project */}
      <Offcanvas
        show={showProject}
        // onHide={handleCloseFilter}
        placement="end"
        style={{ width: "50%" }}
      >
        {/* {showFilter && ( */}
        <Offcanvas.Body className="p-0">
          <AddMilestoneComponent
            // onApply={handleApplyFilter}
            // onClear={handleClearFilter}
            // onCancel={() => setShowFilter(false)}
            FetchPortalUsers={FetchPortalUsers}
            onApply={handleApplyFilter}
            onClear={() => reset()} // Resets to initial values
            onCancel={() => setShowProject(false)}
          />
        </Offcanvas.Body>
        {/* )} */}
      </Offcanvas>
      <CommonDeactivate
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        selectedUser={selectedUser}
        refetchList={FetchPortalUsers}
        deactivatePath="changeUserStatus"
        setSelectedUser={setSelectedUser}
      />

      {/* Add filter */}

      <div className="py-3">
        <Box
          className="d-flex justify-content-between align-items-center"
          sx={{
            border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
            borderRadius: "8px",
            padding: "12px 16px",
            marginBottom: "16px",
            backgroundColor: isDarkMode ? "transparent" : "#fff",
          }}
        >
          {/* <CiFilter /> */}
          <div className="d-flex gap-2 align-items-center me-2">
            <Select value={filter} onChange={handleFilterChange}>
              <MenuItem value={3}>All Users</MenuItem>
              <MenuItem value={2}>Active Users</MenuItem>
              <MenuItem value={1}>In-Active Users</MenuItem>
            </Select>

             <Select
             className="ms-2"
              value={roleFilter}
              onChange={(e) => setRoleFilter(e.target.value)}>
              <MenuItem value="ALL">All Roles</MenuItem>
              <MenuItem value="EMPLOYEE">Employee</MenuItem>
              <MenuItem value="MANAGER">Manager</MenuItem>
              <MenuItem value="ADMIN">Admin</MenuItem>
              <MenuItem value="CONTRACTOR">Contractor</MenuItem>
            </Select>

            <Tooltip arrow
              title={
                <>
                  <div>
                    <span style={{ fontSize: 7 }}>📊</span> Total Users:{" "}
                    {totalCount}
                  </div>
                  <div>
                    <span style={{ fontSize: 7 }}>🟢</span> Active Users:{" "}
                    {activeCount}
                  </div>
                  <div>
                    <span style={{ fontSize: 7 }}>🔴</span> Inactive Users:{" "}
                    {inactiveCount}
                  </div>
                </>
              }
            >
              <IconButton
                sx={{
                  padding: "7px",
                  "&:hover": {
                    backgroundColor: "var(--icon-hover-bg)",
                  },
                }}
              >
                <InfoOutlinedIcon style={{ cursor: "pointer" }} color="error" />
              </IconButton>
            </Tooltip>
          </div>

          <div className="d-flex align-items-center">
            <SearchBar
              placeholder="Search users"
              searchTerm={searchTerm}
              onSearchChange={handleSearchChange}
            />
            {login_user_role === "ADMIN" && (
              <Tooltip title="Add New User" arrow>
                <IconButton
                  sx={{
                    backgroundColor: isDarkMode
                      ? "rgba(67, 105, 255, 0.08)"
                      : "#F1F5FF",
                    borderRadius: "50%",
                    width: "36px",
                    height: "36px",
                    margin: "0 24px 0 16px",
                    "&:hover": {
                      backgroundColor: "var(--icon-hover-bg)",
                    },
                  }}
                  onClick={handleShowProject}
                >
                  <CiCirclePlus className="text-rgbr-blue pro-icon-s" />
                </IconButton>
              </Tooltip>
            )}

            <Tooltip title="Export" arrow>
              <IconButton
                sx={{
                  backgroundColor: isDarkMode
                    ? "rgba(67, 105, 255, 0.08)"
                    : "#F1F5FF",
                  borderRadius: "50%",
                  width: "36px",
                  height: "36px",
                  marginRight: "16px",
                  "&:hover": {
                    backgroundColor: "var(--icon-hover-bg)",
                  },
                }}
                onClick={handleExportUsers}
              >
                <CiExport className="text-rgbr-blue pro-icon-s" />
              </IconButton>
            </Tooltip>
          </div>
        </Box>

        <Box style={{ width: "100%" }}>
          {loading ? (
            <Loader />
          ) : (
            <Box sx={{ height: filteredPortalUsers.length === 0 ? 300 : "100%" }}>
              <DataGrid
                rows={filteredPortalUsers}
                columns={columns}
                onRowClick={handleRowClick}
                loading={loading}
                getRowId={(row) => row.user_id}
                pagination
                pageSizeOptions={[25, 50, 75, 100]}
                onPaginationModelChange={setPaginationModal}
                paginationModel={paginationModal}
                slots={{ noRowsOverlay: CustomNoRowsOverlay }}
                // hideFooter
                disableSelectionOnClick
              />
            </Box>
          )}

          {/* Menu for Action Button Options */}
          <Menu
            anchorEl={menuAnchorEl}
            open={Boolean(menuAnchorEl)}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleUpdate}>
              <PiCopyFill className="me-2" color="blue" />
              Update User
            </MenuItem>
            {/* <MenuItem onClick={handleClone}>
              <FaClone className="me-2" />
              Clone
            </MenuItem> */}
            {/* <CommonDeleteDialog
              name="User"
              id={selectedTask?.user_id}
              statusName={selectedTask?.user_name}
              url="deleteUser"
              refetchList={FetchPortalUsers}
              handleListClose={handleMenuClose}
              // secondRefetchList={}
            /> */}
          </Menu>
        </Box>
      </div>

      <Dialog open={showUpdate} onClose={handleClosePopup} disableEscapeKeyDown>
        <DialogTitle>Confirm Action</DialogTitle>
        <DialogContent>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <form action="" onSubmit={handleSubmit(onSubmit)}>
              <DialogContentText>
                <div className=" d-block  my-3">
                  <label htmlFor="" className=" my-1">
                    Update Name
                  </label>
                  <Controller
                    name="user_name"
                    control={control}
                    defaultValue={userDatas?.user_name}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        placeholder="Update name"
                      />
                    )}
                  />
                </div>
                <div className=" d-block my-2 ">
                  <label htmlFor="" className=" my-1">
                    Update Role
                  </label>
                  <Controller
                    name="user_role"
                    control={control}
                    defaultValue={userDatas?.role}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          renderValue={(selected) =>
                            selected ? selected : "Select Role"
                          }
                        >
                          <MenuItem value="ADMIN">ADMIN</MenuItem>
                          <MenuItem value="MANAGER">MANAGER</MenuItem>
                          <MenuItem value="EMPLOYEE">EMPLOYEE</MenuItem>
                          {/* <MenuItem value="CLIENT">CLIENT</MenuItem> */}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>
                
                <div className=" d-block my-2 ">
                  <label htmlFor="" className=" my-1">
                    Update Designation
                  </label>
                  <Controller
                    name="designation"
                    control={control}
                    // defaultValue={userDatas?.designation}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          {...field}
                          displayEmpty
                          renderValue={(selected) =>
                            selected ? (
                              selected
                            ) : (
                              <span className="lightText">
                                Update designation
                              </span>
                            )
                          }
                        >
                          {get_all_designations?.map((role) => (
                            <MenuItem value={role.designation_name}>
                              {role.designation_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>

                {/* <-----------------------------------Department----------------------------------> */}
                <div className=" d-block my-2 ">
                  <label htmlFor="" className=" my-1">
                    Update Department
                  </label>
                  <Controller
                    name="department_id"
                    control={control}
                    // defaultValue={1}

                    render={({ field }) => (
                      <FormControl fullWidth>
                        <Select
                          displayEmpty
                          {...field}
                          renderValue={(selected) => {
                            const dept = department_list.find(
                              (d) => d.department_id === selected
                            );
                            return dept ? (
                              dept.department_name
                            ) : (
                              <span className="lightText">
                                Update department
                              </span>
                            );
                          }}
                        >
                          {department_list?.map((dept) => (
                            <MenuItem
                              key={dept.department_id}
                              value={dept.department_id}
                            >
                              {dept.department_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                </div>

                {/* year of exp */}
                <div className="row my-2">
                  {/* === Input Row === */}
                  <div className="col-12">
                    <label htmlFor="" className=" my-1">
                      Relevant Experience
                    </label>
                  </div>
                  {/* Year */}
                  <div className="col-md-6">
                    <span className="lightText">Year</span>
                    <FormControl fullWidth>
                      <Controller
                        name="relevant_year"
                        control={control}
                        rules={{ required: "Year is required" }}
                        render={({
                          field: { ref, onChange, value },
                          fieldState: { error },
                        }) => (
                          <>
                            <Select
                              value={value}
                              onChange={onChange}
                              inputRef={ref}
                              displayEmpty
                              IconComponent={ExpandMore}
                              MenuProps={{
                                PaperProps: {
                                  style: { maxHeight: "30vh" },
                                },
                              }}
                              renderValue={(selected) =>
                                selected !== undefined && selected !== null ? (
                                  selected
                                ) : (
                                  <span className="lightText">Year</span>
                                )
                              }
                            >
                              {Years.map((item, index) => (
                                <MenuItem key={index} value={item}>
                                  {item}
                                </MenuItem>
                              ))}
                            </Select>
                            {error && (
                              <span className="errorMsg">{error.message}</span>
                            )}
                          </>
                        )}
                      />
                    </FormControl>
                  </div>
                  {/* <------------------------month------------------------> */}

                  {/* Month */}
                  <div className="col-md-6">
                    <div>
                      <span className="lightText">Month</span>
                    </div>
                    <FormControl fullWidth>
                      <Controller
                        name="relevant_month"
                        control={control}
                        rules={{ required: "Month is required" }}
                        render={({
                          field: { ref, onChange, value },
                          fieldState: { error },
                        }) => (
                          <>
                            <Select
                              value={value}
                              onChange={onChange}
                              inputRef={ref}
                              displayEmpty
                              IconComponent={ExpandMore}
                              MenuProps={{
                                PaperProps: {
                                  style: { maxHeight: "30vh" },
                                },
                              }}
                              renderValue={(selected) =>
                                selected !== undefined && selected !== null ? (
                                  selected
                                ) : (
                                  <span className="lightText">Month</span>
                                )
                              }
                            >
                              {Months.map((item, index) => (
                                <MenuItem key={index} value={item}>
                                  {item}
                                </MenuItem>
                              ))}
                            </Select>
                            {error && (
                              <span className="errorMsg">{error.message}</span>
                            )}
                          </>
                        )}
                      />
                    </FormControl>
                  </div>
                </div>

                <div className="row my-2">
                  <label className="form-label mb-1">
                    {"  "}
                    Date of Joining
                  </label>
                  <div className="d-flex  flex-column w-100">
                    <Controller
                      name="date_of_joining"
                      control={control}
                      render={({ field }) => (
                        <DatePicker
                          {...field}
                          format="DD/MM/YYYY"
                          views={["year", "month", "day"]}
                          onChange={(date) => field.onChange(date)}
                          // maxDate={dayjs()}
                          renderInput={(params) => (
                            <input
                              style={{ width: "120%" }}
                              // className="form-control datepic_ip"
                              {...params}
                            />
                          )}
                        />
                      )}
                    />
                  </div>
                </div>
                {/* <-----------------------------------Department----------------------------------> */}

                <div className=" d-block my-2 ">
                  <label htmlFor="" className=" my-1">
                    Update Skills
                  </label>

                  <Controller
                    name="Area_of_expertise"
                    control={control}
                    // rules={{ required: "Area of expertise field is required" }}
                    render={({ field: { ref, onChange, value } }) => (
                      <Autocomplete
                        multiple
                        inputRef={ref}
                        id="Area_of_expertise"
                        options={skills_list}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.skill_name}
                        value={
                          (value || []).map((id) =>
                            skills_list.find((opt) => opt.skill_id === id)
                          ) || []
                        }
                        onChange={(event, newValue) => {
                          const selectedIds = newValue.map(
                            (skill) => skill.skill_id
                          ); // ✅ fixed
                          onChange(selectedIds);
                        }}
                        renderOption={(props, option, { selected }) => (
                          <li
                            {...props}
                            className="d-flex align-items-center mb-2"
                          >
                            <Checkbox
                              style={{ marginRight: 8 }}
                              checked={selected}
                            />
                            <strong>{option.skill_name}</strong>{" "}
                            {/* ✅ fixed */}
                          </li>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder="Enter Area of Expertise"
                          />
                        )}
                        ListboxProps={{
                          style: {
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr",
                            gap: "8px",
                            paddingLeft: "0",
                          },
                        }}
                      />
                    )}
                  />
                </div>
                {/* <-----------------------------------Department----------------------------------> */}

                {/* <div className=" d-block my-2 ">
                <label htmlFor="" className=" my-1">
                  Update Rate Per Hour
                </label>
                <Controller
                  name="rate_per_hour"
                  control={control}
                  // defaultValue={userDatas?.designation}
                  render={({ field }) => <TextField {...field} fullWidth />}
                />
              </div> */}
              </DialogContentText>
              
              <DialogActions>
                <Button onClick={handleCancel} color="primary">
                  Cancel
                </Button>
                <Button
                  type="submit"
                  // onClick={handleConfirmAction}
                  color="error"
                  // variant="contained"
                >
                  Confirm
                </Button>
              </DialogActions>
            </form>
          </LocalizationProvider>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default PortalUsers;
